import { getSupportPhoneLink } from '@/helpers/getSupportPhoneLink'

export const NUMBER_CAR = 'number_car'
export const LINK_PERSONAL_DATA = 'link_processing_personal_data'
export const LINK_PARKING_RULES = 'link_parking_rules'

export enum AreasSlug {
  KashirskayaPlaza = 'kashirskaya_plaza',
  KapitoliyBelyaevo = 'kapitoliy_belyaevo',
  ParkovkaZil = 'parkovkazil',
}

export const supportPhone = '8 800 200 33 20'
export const supportPhoneLink = getSupportPhoneLink(supportPhone)
export const supportPhoneDashed = supportPhone.replace(/\s+/g, '-')

export const storeLinks = {
  appStore: 'https://www.apple.com/app-store/',
  googlePlay: 'https://play.google.com/store/apps',
  rustore: 'https://www.rustore.ru/catalog',
}

export enum OperatingSystem {
  Android = 'android',
  IOS = 'ios',
  Other = 'other',
}

export const DELAY_PAYMENT_PENDING = 300
export const DELAY_PAYMENT_RESULT = 1000
export const COUNT_REQUEST_PAYMENT_PENDING = 45
export const COUNT_REQUEST_PAYMENT_RESULT = 30